<template>
    <tr
        v-if="draggable"
        :class="rowClasses(row._index)"
        :draggable="draggable"
        @dragstart="onDrag($event, row._index)"
        @drop="onDrop($event, row._index)"
        @dragover="allowDrop($event)"
    >
        <slot></slot>
    </tr>
    <tr :class="rowClasses(row._index)" v-else>
        <slot></slot>
    </tr>
</template>
<script>
export default {
    name: 'TableTr',
    inject: ['tableRoot'],
    provide() {
        // 编辑节点，供cellEdit组件使用
        return { editNode: this }
    },
    props: {
        row: Object,
        prefixCls: String,
        draggable: Boolean,
        sourceData: Object,
    },
    computed: {
        objData() {
            return this.$parent.objData
        },
    },
    created() {
        this.$watch(
            function () {
                // depend track keys
                this.tableRoot
                    .getTrackKeys(this.sourceData)
                    .forEach((k) => this.sourceData[k])

                return this.sourceData
            },
            function (newVal) {
                // 更新追踪状态
                this.tableRoot.saveTrack(newVal)
                // 将变化赋值给rebuildRow
                Object.assign(this.row, newVal)
                // 若克隆/对象存在，则更新
                if (this.tableRoot.cloneData[this.row._index]) {
                    Object.assign(
                        this.tableRoot.cloneData[this.row._index],
                        newVal
                    )
                }
            }
        )
    },
    methods: {
        onDrag(e, index) {
            e.dataTransfer.setData('index', index)
        },
        onDrop(e, index) {
            const dragIndex = e.dataTransfer.getData('index')
            this.$parent.$parent.dragAndDrop(dragIndex, index)
            e.preventDefault()
        },
        allowDrop(e) {
            e.preventDefault()
        },
        rowClasses(_index) {
            return [
                `${this.prefixCls}-row`,
                this.rowClsName(_index),
                {
                    [`${this.prefixCls}-row-highlight`]:
                        this.objData[_index] &&
                        this.objData[_index]._isHighlight,
                    [`${this.prefixCls}-row-hover`]:
                        this.objData[_index] && this.objData[_index]._isHover,
                },
            ]
        },
        rowClsName(_index) {
            return this.$parent.$parent.rowClassName(
                this.objData[_index],
                _index
            )
        },
        // 修改cell数据
        editCellChange(key, val) {
            // 更新数据
            this.tableRoot.updateCurrentRow(this.row._index, {
                [key]: val,
            })
        },
    },
}
</script>
